'use strict';

/**
 * Initialize Klarna Express Checkout button
 * @param {Object} container div container element
 * @param {String} containerId id of the container element
 */
function initKlarnaSignInButton(klarna, action) {
    // Listen for `signin` event to receive signin response object
    klarna.Identity.on("signin", async (signinResponse) => {
        const token = signinResponse?.user_account_linking?.user_account_linking_id_token;
        const userDetails = {
            firstName: signinResponse?.user_account_profile?.given_name,
            lastName: signinResponse?.user_account_profile?.family_name,
            email: signinResponse?.user_account_profile?.email,
            phone: signinResponse?.user_account_profile?.phone
        }
        const userDetailsStringified = encodeURIComponent(JSON.stringify(userDetails));
        const payload = `?token=${token}&userDetails=${userDetailsStringified}`;
        const payloadURL = action + payload;
        
        fetch(payloadURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            }
            return Promise.reject(res);
        }).then(data => {
            window.location.href = data.redirectUrl;
        }).catch(() => {
            location.reload();
        });
      });

      // Listen for `error` event to handle error object
      klarna.Identity.on("error", async (error) => {
        location.reload();
      });
}

window.KlarnaSDKCallback = function () {
    let klarnaSignIn = document.querySelector('#klarnaSignIn');

    if (klarnaSignIn) {
        initKlarnaSignInButton(window.Klarna, klarnaSignIn.dataset.action);
    }
};
